// extracted by mini-css-extract-plugin
export default {"container":"UnderDevelopment_container__JwAaq","description":"UnderDevelopment_description__YfAGH","button":"UnderDevelopment_button__uLNLm"};